import { Component, Input, OnChanges, OnInit, SimpleChanges, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Entitytag } from '@src/app/models/entitytag';
import { Tag } from '@src/app/models/tag';
import { TagaddremoveService } from './service/tagaddremove.service';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-tagaddremove',
  templateUrl: './tagaddremove.component.html',
  styleUrls: ['./tagaddremove.component.css']
})
export class TagaddremoveComponent implements OnInit,OnChanges {
  @Input() tagtype:string;
  @Input() viewmode:boolean
  showSpinner:boolean;
  filtertext:string;
  showTags:boolean;
  @Input() modalmode:boolean;
  @Input() smalltype:boolean;
  taglist:Tag[];
  filteredtaglist:Tag[];
  @Input() entityId:string;
  entitytagList:Entitytag[];
  @Output() tagsloaded = new EventEmitter<boolean>();
  @Output() setProjectload = new EventEmitter<boolean>();

  constructor(private tarsrv: TagaddremoveService, private datastore: DatastoreService, private cdr: ChangeDetectorRef) { }
  
  ngOnChanges(changes: SimpleChanges): void {
    if(changes.entityId && changes.entityId.currentValue && changes.entityId.currentValue !== this.entityId){
      this.entityId = changes.entityId.currentValue;
      this.loadEntityTags();
    }
  }
  
  ngOnInit(): void {
    this.setProjectload.emit(false);
    this.filteredtaglist = [];
    this.showSpinner = true;
    
    // Use cached tags from datastore instead of making individual HTTP calls
    this.datastore.tags$.pipe(untilDestroyed(this)).subscribe(t => {
      this.taglist = t.filter(x => x.tagtype == this.tagtype);
      this.filterTags();
      this.cdr.markForCheck();
    });
    
    // Load entity tags for this specific entity
    this.loadEntityTags();
  }
  
  private loadEntityTags(): void {
    if (this.entityId) {
      this.tarsrv.getEntityTags(this.entityId, this.tagtype).pipe(untilDestroyed(this)).subscribe(elist => {
        this.entitytagList = elist;
        this.filterTags();
        this.showSpinner = false;
        this.cdr.markForCheck();
      });
    } else {
      this.showSpinner = false;
      this.cdr.markForCheck();
    }
  }

  filterTags(){
    this.filteredtaglist = [];
    if(!this.entitytagList || this.entitytagList.length == 0){
      this.filteredtaglist = this.taglist;
    } else if (this.entitytagList && this.taglist){
      // Create a Set of entity tag titles for O(1) lookup instead of O(n) with some()
      const entityTagTitles = new Set(this.entitytagList.map(x => x.title));
      
      // Filter available tags - those not already assigned to the entity
      this.filteredtaglist = this.taglist.filter(tag => !entityTagTitles.has(tag.title));
    }
    this.setProjectload.emit(false);
    this.cdr.markForCheck();
  }
  
  // Apply filter and search text without using pipe - pipes run on every change detection
  getFilteredAndSearchedTags(): Tag[] {
    if (!this.filteredtaglist) {
      return [];
    }
    if (!this.filtertext || this.filtertext.trim() === '') {
      return this.filteredtaglist;
    }
    const searchText = this.filtertext.toLowerCase();
    return this.filteredtaglist.filter(tag => 
      tag.title.toLowerCase().includes(searchText)
    );
  }
  
  // TrackBy function for efficient *ngFor rendering
  trackByTagId(index: number, tag: Tag): string {
    return tag.tagId;
  }
  
  trackByEntityTagId(index: number, etag: Entitytag): string {
    return etag.tagId;
  }

  toggleTags(){
    this.showTags = !this.showTags;
  }

  addTag(tag:Tag){
    if(!this.entitytagList.find(x => x.title == tag.title)){
      this.showSpinner = true;
      this.tarsrv.addTagToEntity(this.entityId, tag).pipe(untilDestroyed(this)).subscribe(result => {
        this.entitytagList.push({
          tagId: tag.tagId,
          title: tag.title,
          tagtype: this.tagtype,
          created: new Date().toDateString(),
          creator: SessionHelper.getUserSub(),
          organizationId: tag.organizationId,
          organizationname: tag.organizationname,
          entityId: this.entityId
        });
        this.filterTags();    
        this.showSpinner = false;
        this.cdr.markForCheck();
      });
    }
  }
  removeTag(entityTag:Entitytag){
    this.showSpinner = true;
    this.tarsrv.removeTagFromEntity(entityTag).pipe(untilDestroyed(this)).subscribe(result => {
      const index = this.entitytagList.indexOf(entityTag);
      if (index > -1) {
        this.entitytagList.splice(index, 1);
      }
      this.filterTags();
      this.showSpinner = false;
      this.cdr.markForCheck();
    });
  }
  createTag(title:string){
    this.showSpinner = true;
    if(this.entitytagList.find(x => x.title == title) == undefined){
   let newtag = new Tag;
   newtag= {tagId: new Date().toDateString(),
    title: title,
    tagtype: this.tagtype,
    created: new Date().toDateString(),
    creator: SessionHelper.getUserSub(),
    organizationId: SessionHelper.getChoosenOrg(),
    organizationname: 'tt'};
    this.tarsrv.saveTag(newtag).pipe(untilDestroyed(this)).subscribe(newid => {
      newtag.tagId = newid;
      this.taglist.push(newtag);
      let newEntitytag = new Entitytag;
      newEntitytag = {
        tagId: newtag.tagId,
        title: newtag.title,
        tagtype: this.tagtype,
        created: new Date().toDateString(),
        creator: SessionHelper.getUserSub(),
        organizationId: newtag.organizationId,
        organizationname: newtag.organizationname,
        entityId: this.entityId
      };
      this.tarsrv.addTagToEntity(newEntitytag.entityId,newtag).pipe(untilDestroyed(this)).subscribe(x => {
        this.entitytagList.push(newEntitytag);
        this.filtertext = "";
        this.filterTags();

      this.showSpinner = false;
      });
      
    }); 
   
  }
  }
}
